import React from 'react'
import Headerbar  from "./components/common/Headerbar";
import Titlebar  from "./components/common/Titlebar";
import PaymentRequestApprovalGrid from './components/payment_approval/PaymentRequestApprovalGrid';

function PaymentRequestApprove() {
  return (
    <><Headerbar /><Titlebar name="Payment Request Approval Form" /><PaymentRequestApprovalGrid/></>
  )
}

export default PaymentRequestApprove